<div class="carousel-wrapper row" *ngIf="store.news">

  <div class="col-lg-8 col-xl-9 pr-lg-0">
    <ngb-carousel #host (slide)="onSlide($event)">
      <ng-template ngbSlide *ngFor="let n of getNotLoggedNews(); let i = index" [id]="i">
        <div class="picsum-img-wrapper" [style.height.px]="500">
          <ng-container *ngIf="n?.newsRecords[0]?.imagePath">
            <img [src]="getCompleteImageUrl(n)" alt="Random first slide">
          </ng-container>
        </div>
        <div class="slide-text">
          <h3 class="title"><a (click)="goToArticle(n)">{{n.title}}</a></h3>
          <p class="description" [innerHTML]="newsTextPreview(n) | safeHtml"></p>
        </div>
      </ng-template>
    </ngb-carousel>
  </div>

  <div class="d-none d-lg-block col-lg-4 col-xl-3 pl-0">
    <div class="carousel-news-title-list">
      <div *ngFor="let n of getNotLoggedNews(); let i = index" (click)="goToSlide(i)" [ngClass]="{'active': activeSlide ? n === activeSlide: i === 0}">
        {{n.title}}
      </div>
    </div>
  </div>
</div>
